import React from 'react';

import PaginationWrapper from 'src/components/Pagination/PaginationWrapper';
import OffersListingContainer from 'src/containers/OffersListingContainer';
import 'src/containers/PaginationContainer.scss';


function PaginationContainer() {
  const text = 'Osoby o podobnych kompetencjach aplikowały na te oferty';

  return (
    <div data-test="section-similar-to-you" styleName="offers">
      <div styleName="offers__header">
        <h2 styleName="header__primary">
          { text }
        </h2>
      </div>

      <PaginationWrapper>
        <OffersListingContainer />
      </PaginationWrapper>

    </div>
  );
}

export default PaginationContainer;
